module.exports = __webpack_public_path__ + "img/PDAC1_CD4Tconv.0f30bfb9.png";